import { useState, useEffect, useRef, useCallback } from 'react';

/**
 * Contagem regressiva da sessão de desafio (~3 min). Ao zerar, dispara `onExpire`.
 *
 * @param {object} params
 * @param {number} [params.seconds=180] duração inicial
 * @param {() => void} [params.onExpire] chamado quando chega a zero
 */
export default function useChallengeCountdown({
  seconds = 180,
  onExpire,
} = {}) {
  const [remaining, setRemaining] = useState(seconds);
  const onExpireRef = useRef(onExpire);
  onExpireRef.current = onExpire;

  useEffect(() => {
    if (remaining <= 0) {
      if (onExpireRef.current) onExpireRef.current();
      return undefined;
    }
    const timerId = setTimeout(() => setRemaining(prev => prev - 1), 1000);
    return () => clearTimeout(timerId);
  }, [remaining]);

  const reset = useCallback(
    (nextSeconds = seconds) => setRemaining(nextSeconds),
    [seconds],
  );

  const minutes = Math.floor(remaining / 60);
  const secs = String(remaining % 60).padStart(2, '0');

  return {
    remaining,
    formatted: `${minutes}:${secs}`,
    expired: remaining <= 0,
    reset,
  };
}
